module.exports = __webpack_public_path__ + "static/media/Neeraj Kumbhar.fab8a89a.webp";